import { render, staticRenderFns } from "./UploadSVG.vue?vue&type=template&id=05c6630e&scoped=true&"
import script from "./UploadSVG.vue?vue&type=script&lang=js&"
export * from "./UploadSVG.vue?vue&type=script&lang=js&"
import style0 from "./UploadSVG.vue?vue&type=style&index=0&id=05c6630e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c6630e",
  null
  
)

export default component.exports